import axios from "axios"

const get = async (url, params) => await axios.get(url, params);

const post = async (url, data, params) => await axios.post(url, data, params)

const update = async (url, data, params) => await axios.put(url, data, params)

export { get, post, update }